// config.js
const config = {
  // baseUrl: "http://192.168.31.205:8085/api",
  // backUrl: "http://192.168.31.205:8080",
  // baseUrl: "http://192.168.31.200:8085/api",
  // backUrl: "http://192.168.31.200:8085/api",
  baseUrl: "/api/yuanma1",
  backUrl: "/api/yuanma1",
};

module.exports = config;